module.exports = __webpack_public_path__ + "static/media/pause.8a495bfd.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Player/pause.svg
 ** module id = 148
 ** module chunks = 0
 **/